module.exports = __webpack_public_path__ + "static/img/map.ebba9c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic/map.jpg
// module id = zg0J
// module chunks = 11